<mat-sidenav-container class="sidenav-container">
  <!-- SIDENAV -->

  <mat-sidenav
    #drawer
    class="sidenav"
    fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="'over'"
    [opened]="false"
  >
    <mat-toolbar>Menu</mat-toolbar>

    <mat-nav-list>
      <a mat-list-item routerLink="/clinical" (click)="drawer.close()">Clinical Dashboard</a>
      <a mat-list-item routerLink="/practice" (click)="drawer.close()">Practice</a>
      <a mat-list-item routerLink="/welby-clinical" (click)="drawer.close()">Welby Clinical</a>
      <a mat-list-item routerLink="/calls" (click)="drawer.close()"><mat-icon>phone</mat-icon> My Calls</a>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <!-- TOP TOOLBAR-->

    <mat-toolbar class="toolbar" *ngIf="auth.isLoggedObservable$ | async">
      <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="drawer.toggle()"
        *ngIf="isHandset$ | async"
      >
        <!-- hides this button unless its on a handet size device rom the TS file-->

        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <img
        *ngIf="(isLightMode$ | async) === false; else lightLogo"
        class="logo"
        src="../../../assets/logo_white.png"
        (click)="data.setTabID(0)"
        routerLink="/signed-in-redirect"
        alt="Welby Inc. logo"
      />
      <ng-template #lightLogo>
        <img
          class="logo"
          alt="Welby Logo"
          src="../../../assets/square_logo.png"
          (click)="data.setTabID(0)"
          routerLink="/signed-in-redirect"
        />
      </ng-template>
      <div fxLayout="row" *ngIf="(isHandset$ | async) === false">
        <!-- This div now only display is the display is not classified as a handset -->
        <a
          class="button"
          mat-button
          joyrideStep="firstStep"
          title="Clinical Dashboard"
          text="Here you can see alerts, tasks and patients. Please click next to see every section"
          *ngIf="roleModel.isClient(auth.user)"
          routerLinkActive="active"
          routerLink="/clinical"
          >Clinical Dashboard
        </a>
        <a
          class="button"
          mat-button
          *ngIf="roleModel.isPracticeAdmin(auth.user)"
          routerLinkActive="active"
          routerLink="/practice"
          >Practice Admin</a
        >
        <a class="button" mat-button *ngIf="roleModel.isWelbyClinical(auth.user)" routerLink="/welby-clinical"
          >Welby Clinical</a
        >
        <a class="button" mat-button *ngIf="roleModel.isWelbyClinical(auth.user)" routerLink="/calls"
          ><mat-icon>phone</mat-icon> My Calls</a
        >
      </div>

      <span class="fill-space"></span>
      <div
        *ngIf="roleModel.isAdmin(auth.user) || roleModel.isClient(auth.user) || roleModel.isWelbyClinical(auth.user)"
        class="shell-search-patient"
        fxLayout="row"
        fxHide.xs="true"
      >
        <app-search-patient-autocomplete
          (patientSelected)="navigateToPatientDetail($event)"
        ></app-search-patient-autocomplete>
      </div>
      <span class="fill-space"></span>
      <div fxLayout="row" fxLayoutGap="20px">
        <div class="bubble-viewers-container">
          <div class="bubble-viewers-item" *ngFor="let viewer of users" matTooltip="{{ viewer.tooltip }}">
            {{ viewer.initials }}
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="flex-start center">
          <mat-icon>dark_mode</mat-icon>
          <mat-slide-toggle [formControl]="themeToggleControl"></mat-slide-toggle>
          <mat-icon>light_mode</mat-icon>
        </div>
      </div>

      <!-- pushes everything over to the right -->

      <div *ngIf="(isHandset$ | async) === false">
        <a mat-button *ngIf="roleModel.isAdmin(auth.user)" routerLink="/admin">Admin</a>
      </div>

      <!-- NOTIFICATIONS -->
      <!--
        Behind `notificationsCanary` in `welby_configuration/featureToggles`: `allowAll: true` shows
        the bell to everyone, `false` only to the listed emails. Outside the group the app looks
        exactly as it did before the panel existed.
      -->
      <ng-container *ngIf="(notificationsEnabled$ | async) && (auth.user$ | async)">
        <!--
          The count is read ONCE, through an object wrapper. Four separate `notificationsUnread$ | async`
          bindings lived here (two for the label, two for the badge) and each `| async` is its own
          subscription — the same mistake the panel's own template warns against.

          Wrapped in `{ count: … }` rather than `*ngIf="notificationsUnread$ | async as count"` because
          that form is falsy at zero: the bell would vanish for anyone with nothing unread, which is
          most people most of the time. An object literal is always truthy.
        -->
        <button
          #notificationsBell
          mat-icon-button
          *ngIf="{ count: notificationsUnread$ | async } as unread"
          (click)="toggleNotifications()"
          [attr.aria-label]="unread.count ? unread.count + ' unread notifications' : 'Notifications'"
          [attr.aria-expanded]="notificationsOpen"
        >
          <!-- The count only renders when there is one, so the bell is not permanently wearing a 0. -->
          <mat-icon [matBadge]="unread.count" [matBadgeHidden]="!unread.count" matBadgeColor="warn" matBadgeSize="small"
            >notifications</mat-icon
          >
        </button>
      </ng-container>

      <!-- DROPDOWN MENU -->
      <button mat-icon-button *ngIf="auth.user$ | async as user" [matMenuTriggerFor]="menu" aria-label="Welby settings">
        <mat-icon>more_vert</mat-icon>
      </button>

      <mat-menu #menu="matMenu">
        <button mat-menu-item routerLink="/profile">
          <span class="dropdown-menu-item-primary">Hi {{ auth.user.firstName }}!</span>
        </button>
        <button mat-menu-item *ngIf="roleModel.isAdmin(auth.user)" routerLink="/admin">Admin Tools</button>
        <button mat-menu-item *ngIf="auth.user$ | async as user" (click)="navigateToIntegrationPage()">
          Integrations
        </button>
        <button mat-menu-item routerLink="/training">Training Materials</button>
        <button mat-menu-item routerLink="/license">Software License</button>
        <button mat-menu-item routerLink="/baa">BAA</button>
        <button mat-menu-item routerLink="/terms">Terms of Use</button>
        <button mat-menu-item (click)="openBugReportForm()">Bug Report</button>
        <button mat-menu-item (click)="startTour()">Start Tour</button>
        <button mat-menu-item>
          <span class="dropdown-menu-item-accent">{{ versionStr }}</span>
        </button>
        <button mat-menu-item *ngIf="auth.user$ | async as user" (click)="logout()">Logout</button>
      </mat-menu>
    </mat-toolbar>

    <!-- TRANSCLUSION -->
    <div class="shell-content-container">
      <ng-content></ng-content>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<button
  *ngIf="(auth.isLoggedObservable$ | async) && !isPatientDetailView"
  mat-raised-button
  [ngClass]="{ 'recently-touched-toggle-open': patientService.recentlyTouched }"
  color="accent"
  class="recently-touched-toggle"
  (click)="patientService.toggleRecentlyTouched()"
  matTooltip="Recently Accessed"
>
  Recents
</button>
<!-- Hidden on patient detail: that view renders its own condensed-bar-aware Recents sidebar -->
<div
  *ngIf="!isPatientDetailView"
  [ngClass]="{ 'recently-touched-sidebar-open': patientService.recentlyTouched }"
  class="recently-touched-sidebar"
>
  <app-recently-touched-list></app-recently-touched-list>
</div>

<!--
  Outside `mat-sidenav-container`, next to the Recents sidebar and for the same reason: both are
  `position: fixed` panels that have to stay pinned under the toolbar while the page scrolls.

  It used to sit inside `mat-sidenav-content`, which works only as long as the drawer stays in
  `over` mode — Material puts a `transform` on that element in `push` and `side` mode, and a
  transformed ancestor makes `fixed` anchor to it instead of the viewport. The panel would go back
  to scrolling away, and nothing about the mode change would suggest the notifications panel as the
  thing that broke. Out here there is no such dependency.
-->
<app-notifications-panel
  *ngIf="notificationsEnabled$ | async"
  [open]="notificationsOpen"
  (closed)="closeNotifications()"
></app-notifications-panel>
